import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./LandingPage.css";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function AccessSuccess() {
  const navigate = useNavigate();
  const [status, setStatus] = useState("verifying");
  const [message, setMessage] = useState("Confirming your payment with Stripe…");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const sessionId = params.get("session_id");
    const grantParam = params.get("grant");
    if (!sessionId && !grantParam) {
      setStatus("error");
      setMessage("No payment information was found in this link.");
      return;
    }

    let attempts = 0;
    const grant = params.get("grant");
    const verify = async () => {
      try {
        if (grant) {
          await axios.post(`${API}/access/grant`, { grant, session_id: sessionId || "" });
        } else {
          await axios.post(`${API}/access/verify`, { session_id: sessionId, origin: window.location.origin });
        }
        setStatus("success");
        setMessage("Payment confirmed. Opening SundayBuilder™…");
        setTimeout(() => navigate("/sundaybuilder"), 1200);
      } catch (e) {
        attempts += 1;
        const code = e?.response?.status;
        if (code === 402 && attempts < 5) {
          setMessage("Payment is still processing…");
          setTimeout(verify, 2500);
          return;
        }
        setStatus("error");
        setMessage(e?.response?.data?.detail || "We couldn't verify your payment.");
      }
    };
    verify();
  }, [navigate]);

  return (
    <div
      className="li-page"
      style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", textAlign: "center" }}
    >
      <div className="li-wrap" style={{ maxWidth: 620 }} data-testid="access-status">
        <div className="li-eyebrow">SundayBuilder™ Access</div>
        <h1 style={{ fontFamily: "'Cormorant Garamond', serif", fontSize: 52, fontWeight: 300, margin: "0 0 18px" }}>
          {status === "success" ? "You're in." : status === "error" ? "We hit a snag." : "Verifying…"}
        </h1>
        <p style={{ color: "var(--muted)", fontSize: 18, lineHeight: 1.8 }}>{message}</p>
        {status === "error" && (
          <a className="li-button" href="/#li-pricing" style={{ marginTop: 24 }} data-testid="access-back-btn">
            Back to Plans
          </a>
        )}
      </div>
    </div>
  );
}
